module.exports = __webpack_public_path__ + "static/media/ico_phone_two.6e36af21.svg";